import { useEffect, useState } from "react";
import { Coffee } from "lucide-react";
import { useAuth } from "../../lib/auth";

const EVERY = 45 * 60 * 1000;
const KEY = "aa_coffee_next";
const SEEN = "aa_coffee_seen";
const GAP = 10 * 60 * 1000;

export const CoffeeBreak = () => {
  const { user } = useAuth();
  const [show, setShow] = useState(false);
  const admin = user?.role === "admin";
  useEffect(() => {
    if (!admin) return undefined;
    // timer restarts when the app was closed on this device for more than 10 minutes
    if (!Number(localStorage.getItem(KEY)) || Date.now() - Number(localStorage.getItem(SEEN) || 0) > GAP) localStorage.setItem(KEY, String(Date.now() + EVERY));
    const tick = () => {
      const now = Date.now();
      if (now - Number(localStorage.getItem(SEEN) || now) > GAP) localStorage.setItem(KEY, String(now + EVERY));
      localStorage.setItem(SEEN, String(now));
      setShow(now >= Number(localStorage.getItem(KEY)));
    };
    tick();
    const t = setInterval(tick, 5000);
    const onStorage = (e) => e.key === KEY && setShow(Date.now() >= Number(e.newValue));
    window.addEventListener("storage", onStorage);
    return () => { clearInterval(t); window.removeEventListener("storage", onStorage); };
  }, [admin]);
  useEffect(() => {
    if (!show) return undefined;
    const onKey = (e) => e.key === "Escape" && (localStorage.setItem(KEY, String(Date.now() + EVERY)), setShow(false));
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [show]);
  if (!admin || !show) return null;
  const close = () => { localStorage.setItem(KEY, String(Date.now() + EVERY)); setShow(false); };
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/30 p-4" onClick={close} data-testid="coffee-break-overlay">
      <div role="dialog" aria-modal="true" aria-label="Coffee break" className="max-w-sm cursor-pointer rounded-3xl border-4 border-[#F5C400] bg-[#FFD60A] p-8 text-center text-[#0A2540] shadow-2xl" data-testid="coffee-break-popup">
        <Coffee size={64} strokeWidth={1.6} className="mx-auto mb-4" data-testid="coffee-break-cup" />
        <p className="font-display text-xl font-bold leading-snug" data-testid="coffee-break-text">Ciao {user.first_name || ""}, sono 45 minuti che sei connesso. E&apos; ora di prenderti una pausa!</p>
      </div>
    </div>
  );
};
